import React from "react";
import _ from "lodash";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { setLocationsQuery } from "../helpers";

import Header from "./Header";
import MobileMenu from "./MobileMenu";
import Sidebar from "./Sidebar";
import MapWrapper from "./MapWrapper";
import Feedback from "./Feedback";
import Results from "./Results";
import Offline from "./Offline";

class Main extends React.Component {
    state = {
        menuOpen: false,
    };

    toggleMenu = () => {
        this.setState({
            menuOpen: !this.state.menuOpen,
        });
    };

    cleanupRoutePlanning = (clearMap = false) => {
        this.props.clearjourneys();
        this.props.clearMap("routes");
        this.props.clearMap("rightClick");
        this.props.removeOverlay("sitewide");
        this.props.setCurrent(false);

        if (clearMap === true) {
            this.props.clearMap("routePlanner");
            this.props.clearAllLocations();
            this.props.clearPOI();

            setLocationsQuery();

            this.props.locations.forEach((location, i) => {
                this.props.setLocation(i);
            });
        }
    };

    cleanupLeisureRides = (clearMap = false) => {
        this.props.clearMap("routes");
        this.props.removeOverlay("sitewide");
        this.props.clearPOI();
    };

    componentDidUpdate(prevProps) {
        const newLocationURL = !_.isEqual(
            this.props.location.pathname,
            prevProps.location.pathname
        );

        if (newLocationURL) {
            // Keep sidebar scrolled to top on page change (due to changing overflow on sub components)
            this.refs.sitewrapper.scrollTop = 0;
        }
    }

    render() {
        const hasResults =
            this.props.currentJourney.currentJourney &&
            this.props.cycleRoutes.gotData
                ? true
                : false;
        const isZoomedRoute =
            this.props.params.ridename ||
            this.props.params.routename ||
            this.props.params.hireCompany
                ? true
                : false;
        const inStreetView = this.props.map.inStreetView;

        return (
            <Offline>
                <div
                    className={`
                        site-wrapper page-${this.props.routes[
                            this.props.routes.length - 1
                        ].path.replace(
                            "/",
                            ""
                        )} url-${window.location.pathname.replace(/\//g, "-")}
                        hasResults-${hasResults}
                        isZoomedRoute-${isZoomedRoute}
                        menuOpen-${this.state.menuOpen}
                    `}
                    ref="sitewrapper"
                >
                    <CSSTransitionGroup
                        transitionName="slide"
                        transitionEnterTimeout={400}
                        transitionLeaveTimeout={400}
                    >
                        {this.state.menuOpen && (
                            <MobileMenu toggleMenu={this.toggleMenu} />
                        )}
                    </CSSTransitionGroup>

                    <Header toggleMenu={this.toggleMenu} {...this.props} />

                    <section className="main-content">
                        <Sidebar
                            cleanupRoutePlanning={this.cleanupRoutePlanning}
                            {...this.props}
                        >
                            {React.cloneElement(this.props.children, this.props)}
                        </Sidebar>

                        <div className="secondary-content">
                            <MapWrapper {...this.props} />

                            <Feedback />

                            {hasResults && (
                                <div className="small-content">
                                    <Results
                                        showbikeParking={window.innerWidth <= 1000}
                                        {...this.props}
                                    />
                                </div>
                            )}
                        </div>
                    </section>
                </div>
            </Offline>
        );
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js